<template>
    <ol class="breadcrumb">
      <li class="breadcrumb-item" v-for="(item, index) in list" :key="index">
        <span class="active" v-if="isLast(index)">{{ showName(item) }}</span>
        <router-link :to="item" v-else>{{ showName(item) }}</router-link>
      </li>
      <a class="breadcrumb__btn" href="https://share.hsforms.com/1CFdWK_cCRNeQrVvB7aEM-w2gbug" target="_blank">
        <b-button variant="danger" class="mx-0">
          Priority Request
        </b-button>
      </a>
    </ol>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    isLast (index) {
      return index === this.list.length - 1
    },
    showName (item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label
      }
      if (item.name) {
        item = item.name
        if (item === 'Review Annual Data') {
          item += ' / ' + this.$route.params['year']
        }
      }
      return item
    }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb {
  display: flex;
  align-items: center;

  &__btn {
    margin-left: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Breadcrumb.vue